const hideChat = (item) => {
    const hideChatElement = document.querySelector("#hide-chat");
    const eyeIcon = hideChatElement.querySelector(".chat-icon-eye");
    const eyeSlashIcon = hideChatElement.querySelector(".chat-icon-eye-slash");
    
    if(item.getAttribute("chatvisible") === 'true') {
        hideChatElement.setAttribute("chatvisible", "false");
        window.rep.hide();
        // Show eye-slash icon, hide eye icon
        if (eyeIcon) eyeIcon.style.display = 'none';
        if (eyeSlashIcon) eyeSlashIcon.style.display = 'block';
    } else {
        window.rep.show();
        hideChatElement.setAttribute("chatvisible", "true");
        // Show eye icon, hide eye-slash icon
        if (eyeIcon) eyeIcon.style.display = 'block';
        if (eyeSlashIcon) eyeSlashIcon.style.display = 'none';
    }
}

// The chat toggle tab stays hidden until the Rep AI widget actually loads, so no dead tab shows
// when Rep is off (and a missing Rep global no longer throws).
document.addEventListener("DOMContentLoaded", () => {
    let tries = 0;
    const bind = () => {
        if (!window.rep || typeof window.rep.on !== 'function') {
            if (++tries < 30) setTimeout(bind, 500);
            return;
        }
        onRepReady();
    };
    bind();
});
function onRepReady() {
    window.rep.on('load', () => {
        const hideChatElement = document.querySelector("#hide-chat");
        if (hideChatElement) {
            hideChatElement.hidden = false;
            hideChatElement.setAttribute("chatvisible", "true");
            // Ensure eye icon is visible on load
            const eyeIcon = hideChatElement.querySelector(".chat-icon-eye");
            const eyeSlashIcon = hideChatElement.querySelector(".chat-icon-eye-slash");
            if (eyeIcon) eyeIcon.style.display = 'block';
            if (eyeSlashIcon) eyeSlashIcon.style.display = 'none';
        }
    });
}